import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {AutenticacaoService} from './compartilhado/servicos/autenticacao.service';
import {GlobalService} from './compartilhado/servicos/global.service';
import {PopUpService} from './compartilhado/componentes/pop-up/pop-up.service';
import {Subscription} from 'rxjs';
import {LocalStorageService} from 'angular-2-local-storage';
import {AppConfigService2} from '../app-config.service';

@Injectable()
export class InterceptorService {
  timeout = 10000;
  inatividade = new Date().getTime() + this.timeout * 60000;
  subsLoginOk: Subscription;
  auxLogin = false;

  constructor(private router: Router,
              private authService: AutenticacaoService,
              private globalService: GlobalService,
              private popUpService: PopUpService,
              private appConfig: AppConfigService2,
              private internalStorage: LocalStorageService) {

    this.popUpService.acessoEncerradoChanged.subscribe(resposta => {
      if (resposta) {
        // this.router.navigate(['acessoencerrado/nt1/acessoencerrado'])
      }
    });

    this.subsLoginOk = this.authService.loginChanged.subscribe(resp => {
      this.auxLogin = resp;
    });

    this.authService.sessionChanged.subscribe(minutos => {
      this.timeout = minutos * 60000;
    });
  }

  encerrarConexao(foiDesconectado?: boolean) {
    if (foiDesconectado) {
     /* localStorage.clear();
      this.authService.isLogged();
      this.router.navigate(['acessoencerrado/nt1/acessoencerrado'])*/
    }
  }

  atualizarSessao() {
    /*if (this.auxLogin) { // Verifica se está logado para executar a lógica
      if (!localStorage) {
        this.router.navigate(['login']);
      }

      // Garante que o tempo de sessão não tenha sido alterado pelo usuário no Internal Storage
      this.internalStorage.set('SessionTimeOut', this.inatividade);
        if (new Date().getTime() > this.internalStorage.get('SessionTimeOut')) {
          this.encerrarConexao(true)
        } else {
          this.inatividade = new Date().getTime() + this.timeout; // Gera um novo prazo para expiração de inatividade.
          this.internalStorage.set('SessionTimeOut', this.inatividade);
        }
      }*/
  }

  checkStatus() {
    if (this.auxLogin) {
  /*    if (new Date().getTime() > this.internalStorage.get('SessionTimeOut')) {
        localStorage.clear();
      }*/
    }

    return true;
  }
}

